// Production builds call https://kiransable.com (set in .env.production).
// In development the address is empty, so calls go through the `npm start` proxy to the local backend.
export const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

/** Uploaded images are stored as "/uploads/..."; this points them at the API server. */
export const assetUrl = (url) => (url && url.startsWith("/") ? `${API_BASE}${url}` : url);

const BASE = API_BASE;
const TOKEN_KEY = "kiranAdminToken";

export const getToken = () => {
  try {
    const raw = localStorage.getItem(TOKEN_KEY);
    if (!raw) return null;
    const { token, expiresAt } = JSON.parse(raw);
    if (Date.now() > expiresAt) {
      localStorage.removeItem(TOKEN_KEY);
      return null;
    }
    return token;
  } catch (e) {
    return null;
  }
};

export const saveToken = (token, expiresInMs) => {
  try {
    localStorage.setItem(TOKEN_KEY, JSON.stringify({ token, expiresAt: Date.now() + expiresInMs - 60000 }));
  } catch (e) {
    // storage blocked: the session just lasts until the tab closes
  }
};

export const clearToken = () => {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch (e) {
    // ignore
  }
};

/** Turns the server's validation map or message into one readable string. */
const messageFrom = (data, status) => {
  if (data && data.data && typeof data.data === "object" && !Array.isArray(data.data)) {
    const parts = Object.values(data.data).filter((v) => typeof v === "string");
    if (parts.length) return parts.join(". ");
  }
  return (data && data.message) || `Request failed (${status})`;
};

export async function api(path, { method = "GET", body, auth = false } = {}) {
  const headers = { Accept: "application/json" };
  const isForm = typeof FormData !== "undefined" && body instanceof FormData;
  if (body !== undefined && !isForm) headers["Content-Type"] = "application/json";
  if (auth) {
    const token = getToken();
    if (token) headers.Authorization = `Bearer ${token}`;
  }

  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : isForm ? body : JSON.stringify(body),
  });

  let data = null;
  try {
    data = await res.json();
  } catch (e) {
    // empty or non-JSON body
  }

  if (res.status === 401 && auth) {
    clearToken();
    window.dispatchEvent(new Event("admin-logout"));
  }
  if (!res.ok) throw new Error(messageFrom(data, res.status));
  return data;
}
